// Tipos para o sistema de permissões e usuários

export type UserRole = 'admin' | 'operator';

export type PermissionModule =
  | 'clientes'
  | 'orcamentos'
  | 'pedidos'
  | 'financeiro'
  | 'estoque'
  | 'relatorios'
  | 'medidas'
  | 'agenda'
  | 'catalogo'
  | 'servicos'
  | 'fornecedores'
  | 'notas_fiscais'
  | 'configuracoes';

export interface ModulePermissions {
  [action: string]: boolean;
}

export type UserPermissions = {
  [key: string]: ModulePermissions;
};

export interface UserEmpresa {
  id: string;
  user_id: string;
  empresa_id: string;
  role: UserRole;
  is_owner: boolean;
  status: 'ativo' | 'inativo';
  created_at: string;
}

export interface Permission {
  id: string;
  user_id: string;
  empresa_id: string;
  module: PermissionModule;
  actions: ModulePermissions;
  created_at: string;
  updated_at: string;
}

export interface AuditLog {
  id: string;
  empresa_id: string;
  user_id: string;
  action: string;
  module: string;
  entity_type?: string;
  entity_id?: string;
  changes?: Record<string, any>;
  ip_address?: string;
  user_agent?: string;
  created_at: string;
}

export interface OperadorInfo {
  id: string;
  email: string;
  full_name: string;
  role: UserRole;
  status: 'ativo' | 'inativo';
  is_owner: boolean;
  ultimo_acesso?: string;
  created_at: string;
}

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Administrador',
  operator: 'Operador'
};

export const PERMISSION_LABELS: Record<string, string> = {
  view: 'Visualizar',
  create: 'Criar',
  edit: 'Editar',
  delete: 'Deletar',
  export: 'Exportar',
  cancel: 'Cancelar',
  alter_values: 'Alterar Valores',
  apply_discount: 'Aplicar Desconto',
  entrada: 'Entrada',
  saida: 'Saída',
  ajuste_manual: 'Ajuste Manual',
  manage_users: 'Gerenciar Usuários',
  manage_payments: 'Gerenciar Pagamentos'
};
